import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "backgroundsSpritesheets/desktop/21_peony/21_peony"
 * Contains 1 texture(s)
 */
export class Desktop21PeonyAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'backgroundsSpritesheets/desktop/21_peony/21_peony';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '21_peony.jpg'
    ] as const;
}
